

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppLayoutWithHeader } from '@/components/layout/AppLayoutWithHeader';
import { CampaignManager } from '@/components/campaign/CampaignManager';
import { useAuth } from '@/hooks/useAuth';
import { useToast } from '@/hooks/use-toast';
import { logger } from '@/utils/productionLogger';

const CreateCampaign = () => {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const { toast } = useToast();

  // Vérification critique : l'utilisateur doit avoir un organization_id
  useEffect(() => {
    if (!profile?.organization_id) {
      logger.error('CreateCampaign: User has no organization_id', {
        userId: profile?.id,
        email: profile?.email
      });
      
      toast({
        title: "Configuration incomplète",
        description: "Votre profil doit être rattaché à une organisation. Veuillez contacter le support.",
        variant: "destructive",
      });
      
      navigate('/dashboard');
    }
  }, [profile, navigate, toast]);

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  return (
    <AppLayoutWithHeader 
      title="Nouvelle campagne" 
      subtitle="Suivez les étapes pour configurer votre campagne"
      showBackButton={true}
      onBack={handleGoBack}
      layoutMode="default"
      sidebarVisible={true}
    >
      <CampaignManager onBack={handleGoBack} />
    </AppLayoutWithHeader>
  );
};

export default CreateCampaign;
